import { types } from "mobx-state-tree";

const MixpanelQueryResult = types.model("MixpanelQueryResult", {
  label: types.string,
  y: types.maybeNull(types.number),
  color: types.string
});

export default MixpanelQueryResult;
